import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { key_KnowledgeDomains } from "../utils/constants";
import { getKnowledgeDomains } from "../services/school/knowledgedomains/knowledgeDomains";


export const useGetKnowledgeDomainsQuery = (data:PagedRequestType) => {
    return useQuery([key_KnowledgeDomains, JSON.stringify(data)], () => getKnowledgeDomains(data));
};
